import React from 'react';
import GoogleOAuthButton from './GoogleOAuthButton';
import GitHubOAuthButton from './GitHubOAuthButton';

const OAuthButtons = () => {
  return (
    <>
      {/* OAuth Divider */}
      <div className="relative my-6">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-gray-300"></div>
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="px-2 bg-white text-gray-500">Or continue with</span>
        </div>
      </div>

      {/* OAuth Buttons */}
      <div className="space-y-3">
        <GoogleOAuthButton />
        <GitHubOAuthButton />
      </div>
    </>
  );
};

export default OAuthButtons;
